import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { useAuth } from "../login/AuthProvider";
import SwitchBox from "../../components/switchBox";
import {switchHelper, dateHelper, dictFinder} from "../../modules/helpers";
import PageList from "../../components/pageList";
import {  share_page, art_type, cate_type, art, backend } from '../../components/apipath';
import HTMLEditor from "../../components/htmleditor";

let newIntroHtml = '';
let newContentHtml = '';
let updateIntroHtml = '';
let updateContentHtml = '';

function AdmShare() {
    
    const [shareData, setShareData] = useState();
    const [artTypeList, setArtTypeList] = useState();
    const [cateTypeList, setCateTypeList] = useState();
    const [rowsCount, setRowsCount] = useState();
    const [editingShare, setEditingShare] = useState(null);
    const [updatedData, setUpdatedData] = useState({});
    const [newShare, setNewShare] = useState();
    const navigate = useNavigate();
    const { token } = useAuth();
    const [page, setPage] = useState(1);
    const [rows, setRows] = useState(50);

    const [search, setSearch] = useState({
    keyword: "",
    startDate: "",
    endDate: "",
    });

    const fetchShareData = async (p = page, r = rows, s = search) => {
  try {
    if (p <= 0) p = 1;

    const res = await axios.get(share_page(p - 1, r), {
      headers: { token },
      params: {
        keyword: s.keyword || undefined,
        startDate: s.startDate || undefined,
        endDate: s.endDate || undefined,
        art_type: s.art_type || undefined,
        cate_id: s.cate_id || undefined,
      },
    });

    const payload = res.data;

    // ✅ list 拆包：支援 data / data.data / 直接是 array
    const list =
      payload?.[0]?.data?.data ??
      payload?.[0]?.data ??
      (Array.isArray(payload?.[0]) ? payload?.[0] : []);

    // ✅ total 拆包
    const total =
      payload?.[1]?.data?.data?.[0]?.total ??
      payload?.[1]?.data?.[0]?.total ??
      0;

    console.log("[AdmShare] list length =", Array.isArray(list) ? list.length : "NOT ARRAY", list);
    console.log("[AdmShare] total =", total);

    setShareData(Array.isArray(list) ? list : []);
    setRowsCount(Number(total) || 0);
  } catch (err) {
    console.error("Error:", err);
    setShareData([]);
    setRowsCount(0);
  }
};



    const fetchArtTypeList = async () => {
        try {
            const response = await axios.get(`${art_type}`, {headers:{token: token}});
            setArtTypeList(response.data.data);
        } catch (error) {
            console.error('Error:', error);
        }
    }

    const fetchCateTypeList = async () => {
        try {
            const response = await axios.get(`${cate_type}`, {headers:{token: token}});
            setCateTypeList(response.data.data);
            //console.log(response)
        } catch (error) {
            console.error('Error:', error);
        }
    }

    useEffect(()=>{
        fetchShareData();
    }, []);

    useEffect(()=>{
        fetchArtTypeList();
    }, []);

    useEffect(()=>{
        fetchCateTypeList();
    }, []);

    const startEditing = (newsItem) => {
        updateIntroHtml = newsItem.intro;
        updateContentHtml = newsItem.content;
        setEditingShare(newsItem);
        setUpdatedData(newsItem);
    };

    
    const handleAddNew = () => {
        setNewShare({
            cate_id: 0,
            cate: '',
            art_type: 0,
            is_top: 0,
            status: 1,
            privilege: 0,
            cate_status: 1,
            title: null,
            intro: null,
            content: null,
            link: '',
            target: '_self',
            cover_1: null,
            cover_file: null,
            art_date: dateHelper(Date.now(), 'date'),
            disp_order: 0,
        });
    };
    const initHtmlEditor = () => {
        newIntroHtml = '';
        newContentHtml = '';
        updateIntroHtml = '';
        updateContentHtml = '';
    }
    const handleNewIntroHtmlChange = (name, content) => {
        newIntroHtml = content;
    }
    const handleNewContentHtmlChange = (name, content) => {
        newContentHtml = content;
    }
    const handleUpdateIntroHtmlChange = (name, content) => {
        updateIntroHtml = content;
    }
    const handleUpdateContentHtmlChange = (name, content) => {
        updateContentHtml = content;
    }

    const handleInputChange = (e) => {
        const { name, value, checked, type } = e.target;
        if (['checkbox'].includes(type)){
            setUpdatedData({
                new_id: editingShare.new_id,
                ...updatedData,
                [name]: switchHelper(checked),
            });
        } else if (name === 'art_type') {
            setNewShare({
                ...editingShare,
                [name]: value,
                art_type_name: dictFinder(artTypeList, 'art_type', value).name
            });
        } else if (name === 'cate_id') {
            setNewShare({
                ...editingShare,
                [name]: value,
                cate: dictFinder(cateTypeList, 'cate_id', value).title
            });
        } else if (name === 'cover_1') {
            if (e.target.files){
                setUpdatedData({
                    ...updatedData,
                    [name]: value,
                    cover_file: e.target.files[0],
                });
            } else {
                setUpdatedData({
                    ...updatedData,
                    [name]: value,
                });
            }
        } else {
            setUpdatedData({
                new_id: editingShare.new_id,
                ...updatedData,
                [name]: value,
            });
        }
    };

    const handleSaveChanges = async () => {
    try {
        let uploadedCoverPath = updatedData.cover_1;

        if (updatedData.cover_file) {
        const formData = new FormData();
        formData.append("file", updatedData.cover_file);

        const uploadRes = await axios.post(`${art}upload`, formData, {
            headers: { "Content-Type": "multipart/form-data", token },
        });

        if (uploadRes.status === 200 && uploadRes.data.filePath) {
            uploadedCoverPath = uploadRes.data.filePath;
        } else {
            throw new Error("圖片上傳失敗");
        }
        }

        // ✅ 保底：如果 editor 目前是空字串，就沿用原本資料，不要覆蓋
        const safeIntro =
        (updateIntroHtml !== undefined && updateIntroHtml !== null && updateIntroHtml !== "")
            ? updateIntroHtml
            : (updatedData.intro ?? editingShare.intro ?? "");

        const safeContent =
        (updateContentHtml !== undefined && updateContentHtml !== null && updateContentHtml !== "")
            ? updateContentHtml
            : (updatedData.content ?? editingShare.content ?? "");

        const updateDatas = {
        ...updatedData,
        intro: safeIntro,
        content: safeContent,
        cover_1: uploadedCoverPath,
        };

        const response = await axios.put(`${art}`, updateDatas, {
        headers: { Authorization: `Bearer ${token}`, token },
        });

        if (response.data.status !== 200) throw new Error(response.data.msg);

        const updatedShareList = shareData.map(s =>
        s.art_id === editingShare.art_id ? updateDatas : s
        );
        setShareData(updatedShareList);

        initHtmlEditor();
        setEditingShare(null);
    } catch (error) {
        console.error("Error updating share:", error);
    }
    };


    const handleDeleted = async (id) => {
        if(window.confirm("確認刪除 ?")){
            try{
                const res = await axios.delete(`${art}${id}`, {data: { art_id: id }, headers: {
                    Authorization: `Bearer ${token}`,
                    token: token,
                    "Content-Type": "application/json"
                  }});
                if (res.data.status !== 200)
                    console.error(res.data.msg);
                else
                    fetchShareData();
            } catch(err){
                console.error(err)
            }
            
        }
    }

    const handleSaveNew = async () => {
        try {
            let uploadedCoverPath = null;
    
            // 🟡 先上傳圖片
            if (newShare.cover_file) {
                const formData = new FormData();
                formData.append("file", newShare.cover_file);
    
                const uploadRes = await axios.post(`${art}upload`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        token,
                    },
                });
    
                if (uploadRes.status === 200 && uploadRes.data.filePath) {
                    uploadedCoverPath = uploadRes.data.filePath;
                } else {
                    throw new Error("圖片上傳失敗");
                }
            }
    
            // ✅ 組裝要送出的資料（只送路徑）
            const shareDatas = {
                ...newShare,
                intro: newIntroHtml,
                content: newContentHtml,
                cover_1: uploadedCoverPath,
            };
    
            const response = await axios.post(`${art}`, shareDatas, {
                headers: { token },
            });
    
            if (response.data.status !== 200)
                throw new Error(response.data.msg);
    
            fetchShareData();
            initHtmlEditor();
            setEditingShare(null);
            setNewShare(null);
        } catch (error) {
            console.error("Error insert share:", error);
        }
    };
    const handleNewInputChange = (e) => {
        const { name, value, checked, type } = e.target;
        if (['checkbox'].includes(type)){
            setNewShare({
                ...newShare,
                [name]: switchHelper(checked),
            });
        } else if (name === 'art_type') {
            setNewShare({
                ...newShare,
                [name]: value,
                art_type_name: dictFinder(artTypeList, 'art_type', value).name
            });
        } else if (name === 'cate_id') {
            setNewShare({
                ...newShare,
                [name]: value,
                cate: dictFinder(cateTypeList, 'cate_id', value).title
            });
        } else if (name === 'cover_1') {
            if (e.target.files){
                setNewShare({
                    ...newShare,
                    [name]: value,
                    cover_file: e.target.files[0],
                });
            } else {
                setNewShare({
                    ...newShare,
                    [name]: value,
                });
            }
        } else {
            setNewShare({
                ...newShare,
                [name]: value,
            });
        }
    };
    const handleSearchClick = () => {
    setPage(1);
    fetchShareData(1, rows, search);
    };


    return (
        <>
        <div className="mt100 container">
            <div className="text-end mt-2">
                <button className="btn btn-success me-2" onClick={handleAddNew}>新增</button>
            </div>
            {/* 🔎 搜尋列 */}
            <div className="card p-3 my-2">
            <div className="row g-2">
                <div className="col-md-3 col-12">
                <div className="input-group input-group-sm">
                    <span className="input-group-text">關鍵字</span>
                    <input
                    className="form-control form-control-sm"
                    type="text"
                    placeholder="標題／副標／內容"
                    value={search.keyword}
                    onChange={(e) => setSearch(s => ({ ...s, keyword: e.target.value }))}
                    onKeyDown={(e) => e.key === 'Enter' && handleSearchClick()}
                    />
                </div>
                </div>

                <div className="col-md-2 col-6">
                <div className="input-group input-group-sm">
                    <span className="input-group-text">開始日</span>
                    <input
                    type="date"
                    className="form-control form-control-sm"
                    value={search.startDate}
                    onChange={(e) => setSearch(s => ({ ...s, startDate: e.target.value }))}
                    />
                </div>
                </div>

                <div className="col-md-2 col-6">
                <div className="input-group input-group-sm">
                    <span className="input-group-text">結束日</span>
                    <input
                    type="date"
                    className="form-control form-control-sm"
                    value={search.endDate}
                    onChange={(e) => setSearch(s => ({ ...s, endDate: e.target.value }))}
                    />
                </div>
                </div>

                <div className="col-md-3 col-12 d-flex gap-2">
                <button className="btn btn-primary btn-sm" onClick={handleSearchClick}>搜尋</button>
                <button
                    className="btn btn-outline-secondary btn-sm"
                    onClick={() => {
                        const empty = { keyword: "", art_type: "", startDate: "", endDate: "", cate_id: "" };
                        setSearch(empty);
                        setPage(1);
                        fetchShareData(1, rows, empty);
                    }}
                    >
                    清除
                </button>

                </div>
            </div>
            </div>
            {/* 🔎 搜尋列結束 */}
            <div className="mt-2">
                <table className="table table-striped border">
                    <thead>
                        <tr>
                            <th scope="col">主標</th>
                            <th scope="col">副標</th>
                            <th scope="col">連結</th>
                            <th scope="col">圖片</th>
                            <th scope="col">功能</th>
                        </tr>
                    </thead>
                    <tbody>
                        { newShare && (
                            <tr key={0}>
                                <td colSpan={4}>
                                    <div className="container">
                                        <div className="row g-2">
                                            <div className="col-xl-3 col-md-4 col-6">
                                                <div className="input-group input-group-sm">
                                                    <span className="input-group-text">文章分類</span>
                                                    <select 
                                                        className="form-select form-select-sm"
                                                        name="art_type"
                                                        onChange={handleNewInputChange}
                                                        required
                                                    >
                                                        <option key={0} value={''}>請選擇</option>
                                                        {artTypeList.map((art)=>(
                                                            <option key={art.type_id} value={art.type_id}>{art.name}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-xl-3 col-md-4 col-6">
                                                <div className="input-group input-group-sm">
                                                    <span className="input-group-text">類別分類</span>
                                                    <select 
                                                        className="form-select form-select-sm"
                                                        name="cate_id"
                                                        onChange={handleNewInputChange}
                                                        required
                                                    >
                                                        <option key={0} value={''}>請選擇</option>
                                                        {cateTypeList.map((cate)=>(
                                                            <option key={cate.cate_id} value={cate.cate_id}>{cate.title}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-xl-3 col-md-4 col-6">
                                                <div className="input-group input-group-sm">
                                                    <span className="input-group-text">文章日期</span>
                                                    <input
                                                        type="date"
                                                        name="art_date"
                                                        className="form-control form-control-sm"
                                                        onChange={handleNewInputChange}
                                                        defaultValue={dateHelper(Date.now(), 'date')}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-xl-3 col-md-4 col-6">
                                                <div className="input-group input-group-sm">
                                                    <span className="input-group-text">影片連結</span>
                                                    <input
                                                        type="text"
                                                        name="link"
                                                        className="form-control form-control-sm"
                                                        onChange={handleNewInputChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-xl-3 col-md-4 col-6">
                                                <div className="input-group input-group-sm">
                                                    <span className="input-group-text">開啟方式</span>
                                                    <select 
                                                        className="form-select form-select-sm"
                                                        name="target"
                                                        defaultValue={'_self'}
                                                        onChange={handleNewInputChange}
                                                    >
                                                        <option key={0} value={'_self'}>self</option>
                                                        <option key={1} value={'_blank'}>blank</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-xl-3 col-md-4 col-6">
                                                <div className="input-group input-group-sm">
                                                    <span className="input-group-text">圖片</span>
                                                    <input
                                                        type="file"
                                                        name="cover_1"
                                                        className="file form-control form-control-sm"
                                                        onChange={handleNewInputChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-xl-1 col-md-2 col-3">
                                                <div className="input-group input-group-sm">
                                                    { SwitchBox('status', 1, handleNewInputChange, '啟用') }
                                                </div>
                                            </div>
                                            <div className="col-xl-1 col-md-2 col-3">
                                                <div className="input-group input-group-sm">
                                                    { SwitchBox('is_top', 0, handleNewInputChange, '頂置') }
                                                </div>
                                            </div>
                                            <div className="col-xl-12 col-md-12 col-12">
                                                <div className="input-group input-group-sm">
                                                    <span className="input-group-text">主題</span>
                                                    <input
                                                        type="text"
                                                        name="title"
                                                        className="form-control form-control-sm"
                                                        onChange={handleNewInputChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div className="input-group">
                                                    <span className="input-group-text">副標</span>
                                                    { HTMLEditor('', 'intro', handleNewIntroHtmlChange) }
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div className="input-group">
                                                    <span className="input-group-text">文章</span>
                                                    { HTMLEditor('', 'content', handleNewContentHtmlChange) }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td className="text-center">
                                    <button className="btn btn-sm btn-primary m-1" onClick={handleSaveNew}>儲存</button>
                                    <button className="btn btn-sm btn-danger m-1" onClick={()=>{
                                        setNewShare(null);
                                        initHtmlEditor();
                                    }}>取消</button>
                                </td>
                            </tr>
                        )}
                        { shareData && shareData.map((share)=>(
                            <tr key={share.art_id}>
                                {editingShare && editingShare.art_id === share.art_id ? (
                                    <>
                                    <td colSpan={4}>
                                        <div className="container">
                                            <div className="row g-2">
                                                <div className="col-xl-3 col-md-4 col-6">
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text">文章分類</span>
                                                        <select 
                                                            className="form-select form-select-sm"
                                                            name="art_type"
                                                            onChange={handleInputChange}
                                                            required
                                                            defaultValue={share.art_type}
                                                        >
                                                            <option key={0} value={''}>請選擇</option>
                                                            {artTypeList.map((art)=>(
                                                                <option key={art.type_id} value={art.type_id}>{art.name}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-xl-3 col-md-4 col-6">
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text">類別分類</span>
                                                        <select 
                                                            className="form-select form-select-sm"
                                                            name="cate_id"
                                                            onChange={handleInputChange}
                                                            required
                                                            defaultValue={share.cate_id}
                                                        >
                                                            <option key={0} value={''}>請選擇</option>
                                                            {cateTypeList.map((cate)=>(
                                                                <option key={cate.cate_id} value={cate.cate_id}>{cate.title}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-xl-3 col-md-4 col-6">
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text">文章日期</span>
                                                        <input
                                                            type="date"
                                                            name="art_date"
                                                            className="form-control form-control-sm"
                                                            onChange={handleInputChange}
                                                            defaultValue={dateHelper(share.art_date, 'date')}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-xl-3 col-md-4 col-6">
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text">影片連結</span>
                                                        <input
                                                            type="text"
                                                            name="link"
                                                            className="form-control form-control-sm"
                                                            onChange={handleInputChange}
                                                            defaultValue={share.link}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-xl-3 col-md-4 col-6">
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text">開啟方式</span>
                                                        <select 
                                                            className="form-select form-select-sm"
                                                            name="target"
                                                            defaultValue={share.target}
                                                            onChange={handleInputChange}
                                                        >
                                                            <option key={0} value={'_self'}>self</option>
                                                            <option key={1} value={'_blank'}>blank</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-xl-3 col-md-4 col-6">
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text">圖片</span>
                                                        <input
                                                            type="file"
                                                            name="cover_1"
                                                            className="file form-control form-control-sm"
                                                            onChange={handleInputChange}
                                                        />
                                                        <span className="input-group-text">
                                                            {share.cover_1 ? "再次上傳檔案" : "請選擇檔案"}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="col-xl-3 col-md-4 col-6">
                                                    <div style={{maxWidth: "200px"}}>
                                                        <img style={{maxWidth: "200px"}} src={share.cover_1} alt="" />
                                                    </div>
                                                </div>
                                                <div className="col-xl-1 col-md-2 col-3">
                                                    <div className="input-group input-group-sm">
                                                        { SwitchBox('status', share.status, handleInputChange, '啟用') }
                                                    </div>
                                                </div>
                                                <div className="col-xl-1 col-md-2 col-3">
                                                    <div className="input-group input-group-sm">
                                                        { SwitchBox('is_top', share.is_top, handleInputChange, '頂置') }
                                                    </div>
                                                </div>
                                                <div className="col-xl-12 col-md-12 col-12">
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text">主題</span>
                                                        <input
                                                            type="text"
                                                            name="title"
                                                            className="form-control form-control-sm"
                                                            onChange={handleInputChange}
                                                            defaultValue={share.title}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="input-group">
                                                        <span className="input-group-text">副標</span>
                                                        { HTMLEditor(share.intro, 'intro', handleUpdateIntroHtmlChange) }
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="input-group">
                                                        <span className="input-group-text">文章</span>
                                                        { HTMLEditor(share.content, 'content', handleUpdateContentHtmlChange) }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="text-center">
                                        <button className="btn btn-sm btn-primary m-1" onClick={handleSaveChanges}>儲存</button>
                                        <button className="btn btn-sm btn-danger m-1" onClick={()=>{
                                            setEditingShare(null);
                                            initHtmlEditor();
                                        }}>取消</button>
                                    </td>
                                    </>
                                    ) : (
                                    <>
                                    <td>
                                        <div className="mb-2">
                                            {share.is_top ? (<i className="fa-solid fa-thumbtack fa-fw me-1 text-success"></i>) : ''} 
                                            {!share.status ? (<i className="fa-regular fa-eye-slash fa-fw me-1 text-danger"></i>) : <i className="fa-regular fa-eye me-1 text-warning"></i>} 
                                            <strong>{share.cate}</strong>
                                        </div>
                                        {share.title}
                                    </td>
                                    <td><div dangerouslySetInnerHTML={{__html:share.intro}}></div></td>
                                    <td className="text-center"><a className="btn btn-link btn-sm" target={share.target} href={share.link}>{share.link}</a></td>
                                    <td className="col-2"><div className="text-center" style={{maxWidth:"150px"}}><img style={{width: "100%"}} src={`${share.cover_1}`} alt="" /></div></td>
                                    <td className="text-center">
                                        <button className="btn btn-sm btn-primary m-1" onClick={()=> startEditing(share)}>編輯</button>
                                        <button className="btn btn-sm btn-danger m-1" onClick={()=> handleDeleted(share.art_id)}>刪除</button>
                                    </td>
                                    </>
                                    )
                                }
                                
                            </tr>
                        )) }
                        
                    </tbody>
                </table>
            </div>
        </div>
        <div className="m-2 p-2">
            { PageList(rowsCount, (p, r) => {
                setPage(p);
                setRows(r ?? rows);
                fetchShareData(p, r ?? rows, search);
            }) }

        </div>
        </>
    );
}
export default AdmShare;